<template>
    <svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
        <path d="M45 60V15h15v45H45zm-22.5 0V0h15v60h-15zM0 60V30h15v30H0z" fill="#06B0F0" fill-rule="nonzero"/>
    </svg>
</template>

<script>
export default {
    name: 'IconChart',
};
</script>
